<template>
	<TeamingDropDown
		:class="className"
		:disabled="disabled"
		:options="userList"
		altValueField="personId"
		:value="value?.personId"
		:width="width"
		@change="onChange"
	>
		<template v-slot:selected="{ selectedOption, onSelectorClicked }">
			<div
				class="teaming-user-dropdown_user-row"
				@click="onSelectorClicked"
			>
				<div
					v-if="selectedOption.personId"
					class="teaming-user-dropdown__avatar"
					@click="onSelectorClicked"
				>
					<UserAvatarSpread
						:users="[ selectedOption, ]"
					/>
				</div>
				<div
					class="teaming-user-dropdown__name"
					@click="onSelectorClicked"
				>
					{{ selectedOption.displayName }}
				</div>
			</div>
		</template>
		<template v-slot:options="{ option, onOptionClicked }">
			<div
				class="teaming-user-dropdown_user-row"
				@click="onOptionClicked(option, $event)"
			>
				<div class="teaming-user-dropdown__avatar">
					<UserAvatarSpread
						:users="[ option ]"
					/>
				</div>
				<div class="teaming-user-dropdown__name">
					{{ option.displayName }}
				</div>
			</div>
		</template>
	</TeamingDropDown>
</template>

<script>
import TeamingDropDown from "./TeamingDropDown";
import UserAvatarSpread from "./UserAvatarSpread";

export default {
	name: "TeamingUserDropDown",

	emits: [ "change", ],

	components: {
		TeamingDropDown,
		UserAvatarSpread,
	},

	props: {
		value: {
			type: Object,
			default: () => ( {} ),
		},
		userList: {
			type: Array,
			default: () => [],
		},
		className: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: "",
		},
	},

	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-user-dropdown_user-row {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}

.teaming-user-dropdown__avatar {
	.user-avatar-spread {
		display: flex;
	}
}

.teaming-user-dropdown__name {
	@include font-and-line-for(0);
	color: $teaming-user-dropdown-font-color;
}
</style>
